import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { appUrl } from "Utils/UrlUtils";
import { Resources, useResource } from "Translations/Resources";
import { CampaignCreateContent } from "Components/Admin/Campaigns/CampaignCreateContent";

export const CampaignCreatePage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.AdminCampaignCreate)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("admin-campaigns"),
      }}
    >
      <StyledPageWrapper>
        <CampaignCreateContent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default CampaignCreatePage;
